module.exports = __webpack_public_path__ + "static/media/RUR.562474ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencies/RUR.svg
// module id = 2369
// module chunks = 7